import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import shpjs from 'shpjs';
import { useNotifications, useFields } from 'hooks';
import JSZip from 'jszip';
import { kml } from '@tmcw/togeojson';
import { DOMParser } from 'xmldom';

const GeometryFileImport = ({ setGeometry }) => {
  const { t } = useTranslation();
  const { setError, setSuccess } = useNotifications();
  const { setGeometryLoad } = useFields();
  const fileInput = useRef();

  const runUploader = () => {
    fileInput.current.click();
  };

  const uploadFile = (file) => {
    const targ = file.target.files[0];
    if (targ.name.endsWith('.kmz')) {
      importKmlFile(targ);
    } else {
      importShpFile(targ);
    }
  };

  const parseAndSetGeometry = (geoJson) => {
    const fieldList = {};

    if (geoJson.features.length > 0) {
      fieldList.type = geoJson.features[0].geometry.type;
      fieldList.coordinates = geoJson.features[0].geometry.coordinates.slice(0, 2);
    } else {
      throw new Error('No geojson received, or invalid file supplied.');
    }
    setGeometry({ ...fieldList });
    setSuccess('Successfully read geometry data. Ready for Upload.', 'Success!');
    setGeometryLoad(true);
  };

  const importKmlFile = (kmzFileZip) => {
    var zip = new JSZip();
    const kmlD = zip.loadAsync(kmzFileZip).then((zip) => {
      let kmlDom = null;
      zip.forEach((relativePath, zipEntry) => {
        if (relativePath.endsWith('.kml')) {
          kmlDom = zipEntry.async('string');
        }
      });
      return kmlDom || Promise.reject('No KML file found in archive.');
    });

    if (kmlD) {
      kmlD
        .then((kmlDom) => {
          const parsedDom = new DOMParser().parseFromString(kmlDom, 'text/xml');
          let geoJson = kml(parsedDom);
          if (geoJson) {
            parseAndSetGeometry(geoJson);
          }
        })
        .catch((err) => {
          if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
            console.log('importKmlFile: ', err);
          }
          setError('File uploaded does not contain properly formatted geometry data. Please try another.');
          setGeometryLoad(false);
        });
    }
  };

  const importShpFile = (fieldData) => {
    const reader = new FileReader();
    reader.onload = function () {
      shpjs(reader.result)
        .then((geojson) => {
          parseAndSetGeometry(geojson);
        })
        .catch((err) => {
          if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
            console.log('importShpFil', err);
          }
          setError('File uploaded does not contain properly formatted geometry data. Please try another.');
          setGeometryLoad(false);
        });
    };

    reader.readAsArrayBuffer(fieldData);
  };

  return (
    <div>
      <Button variant="contained" disableElevation key="edit" onClick={runUploader}>
        {t('upload_fields_title')}
      </Button>
      <input ref={fileInput} type="file" style={{ display: 'none' }} accept=".zip,.kmz" onChange={uploadFile}></input>
    </div>
  );
};

GeometryFileImport.propTypes = {
  geometry: PropTypes.object,
  setGeometry: PropTypes.func.isRequired,
};

export default GeometryFileImport;
